import React from "react";
import { PostulationFormEditApplicant } from '@rankmi/ats-app'

const PostulationFormEditApplicantPage = ({ tenant_id, uid, token }) => {
  return (
    <PostulationFormEditApplicant applicantUid={uid} tenantId={tenant_id} token={token} />
  )
}
export default PostulationFormEditApplicantPage
